import { CANCEL_REASON_OPTIONS } from "../PickupCorporateFilterOptions"

export type PickupCorporateKeywordField =
  | 'order_id'
  | 'customer_name'
  | 'client_name'
  | 'client_id'
  | 'latest_courier'
  | 'phone_number'

export type PickupCorporateSpecialHandlingFilterFlag =
  | 'dangerous_goods'
  | 'quarantine'
  | 'wood_packing'

export type PickupCorporateOriginCountry = 'ID' | 'MY'

export interface PickupCorporateFilterModel {
  keyword: string
  keywordField: PickupCorporateKeywordField
  estimatePickupTime: string | null
  cancelReason: string[]
  originCountry: PickupCorporateOriginCountry | null
  specialHandling: PickupCorporateSpecialHandlingFilterFlag[]
  executionPlatform?: string
}

export interface PickupCorporateSearchFieldOption {
  label: string
  value: PickupCorporateKeywordField
}

export function countActiveFilters(
  model: PickupCorporateFilterModel,
  hideOriginCountry = false
): number {
  let n = model.specialHandling.length
  if (model.estimatePickupTime) n += 1
  if (!hideOriginCountry && model.originCountry) n += 1
  n += model.cancelReason.length;
  return n
}

/**
 * Pure helper untuk transform filter model ke query payload BE (GENESIS-18547)
 */
export function toListQueryFilterPayload(
  model: PickupCorporateFilterModel,
  hideOriginCountry = false
): Record<string, string> {
  const out: Record<string, string> = {}

  if (model.keyword && model.keyword.trim().length >= 3) {
    out.keyword = model.keyword.trim()
    out.keyword_field = model.keywordField
  }

  if (model.estimatePickupTime) {
    out.estimate_pickup_time = model.estimatePickupTime
  }

  if (model.specialHandling && model.specialHandling.length > 0) {
    out.special_handling = model.specialHandling.join(',')
  }

  if (!hideOriginCountry && model.originCountry) {
    out.origin_country = model.originCountry
  }

  if (model.cancelReason.length) {
    out.reason_id = model.cancelReason.map(type => {
      return CANCEL_REASON_OPTIONS.find(option => option.label === type)?.value
    }).join(',')
  }

  return out
}
